import EnumClass, { build } from '../EnumClass';
import data, { PaymentStatusId, PaymentStatusData } from './data';
import * as Translations from './translations';

export class PaymentStatus extends EnumClass<PaymentStatusId, PaymentStatusData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: PAYMENT_STATUSES,
  getById: getPaymentStatusById,
  marshaller: PaymentStatusMarshaller,
} = build<PaymentStatusId, PaymentStatusData, PaymentStatus>('PaymentStatusEnum', data, PaymentStatus);
